import { render } from "./BigBanner.vue?vue&type=template&id=e03f74ae&scoped=true"
import script from "./BigBanner.vue?vue&type=script&lang=js"
export * from "./BigBanner.vue?vue&type=script&lang=js"

import "./BigBanner.vue?vue&type=style&index=0&id=e03f74ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e03f74ae"]])

export default __exports__